import React from 'react';
import './CallParticipantList.scss';
import {  AudioOffHoc, AudioOnHoc, VideoOffHoc, VideoOnHoc } from '../../../assets/images';
import { capitalizeFirstLetter } from '../../../Helpers/Utility';
import { CALL_BUSY_STATUS_MESSAGE, CALL_ENGAGED_STATUS_MESSAGE, CALL_HOLD_STATUS_MESSAGE, CALL_STATUS_BUSY, CALL_STATUS_CALLING, CALL_STATUS_CONNECTING, CALL_STATUS_DISCONNECTED, CALL_STATUS_ENGAGED, CALL_STATUS_HOLD, CALL_STATUS_RECONNECT, CALL_STATUS_RINGING } from '../../../Helpers/Call/Constant';
import { getFromLocalStorageAndDecrypt } from '../../../Helpers/Chat/webChatEncryptDecrypt';
import ProfileImage from '../../Common/ProfileImage';

const CallParticipantList = (props) => {
    const {userStatus , initialName ,imageUrl ,name,audioMuted,videoMuted,roster} = props;
    const token = getFromLocalStorageAndDecrypt('token');
    let userStatusDisplay = "";
    if(userStatus && userStatus.toLowerCase() !== CALL_STATUS_DISCONNECTED){
        if(userStatus.toLowerCase() === CALL_STATUS_BUSY){
            userStatusDisplay = CALL_BUSY_STATUS_MESSAGE;
        } else if(userStatus.toLowerCase() === CALL_STATUS_ENGAGED){
            userStatusDisplay = CALL_ENGAGED_STATUS_MESSAGE;
        } else if(userStatus.toLowerCase() === CALL_STATUS_HOLD){
            userStatusDisplay = CALL_HOLD_STATUS_MESSAGE;
        } else {
            userStatusDisplay = capitalizeFirstLetter(userStatus.toLowerCase())
        }
    }
    const statusAimation = (UserStatus) => {
        const userStatusText =  UserStatus && UserStatus.toLowerCase();
        return userStatusText === CALL_STATUS_RINGING || userStatusText === CALL_STATUS_CONNECTING ||  userStatusText === CALL_STATUS_RECONNECT || userStatusText === CALL_STATUS_CALLING ? true : false;
    }

    return(
        <li key={roster?.userId}>
        <div>
            <ProfileImage
                name = {initialName}
                chatType='chat'
                userToken={token}
                temporary={false}
                imageToken={imageUrl}
            />
            <span className="name">{name}</span>
            {userStatus ==="CONNECTED" ?
            <div className="callStatusIcon">
                <i className={audioMuted ? "audio mute" : "audio" }>
                    { audioMuted ? <AudioOffHoc  viewBox="0 0 19.144 20.207"/> : <AudioOnHoc viewBox="0 0 10.765 14.609"/> }
                </i>
                <i className={videoMuted ? "video mute" : "video" }>
                    { videoMuted ? <VideoOffHoc viewBox="0 0 13.802 12.882"/> : <VideoOnHoc viewBox="0 0 15.071 9.545"/> }
                </i>
            </div>
            :
            <div className="callStatusText">
                {userStatusDisplay}{statusAimation(userStatus) &&
                <div className="callingAnimation">
                    <span className="dot"></span>
                    <span className="dot"></span>
                    <span className="dot"></span>
                </div>
                }
            </div>
            }
        </div>
        </li>    
    )}

export default CallParticipantList;

